<template>
  <div ref="root" class="mx-auto w-full max-w-5xl px-4">
    <p class="font-mono text-sm text-[var(--accent)]">{{ t('projects.title') }}</p>
    <h2 class="mt-1 text-2xl font-bold">{{ t('projects.heading') }}</h2>
    <p class="mt-1 text-sm text-[var(--muted)]">{{ t('projects.sub') }}</p>
    <div
      data-reveal-group
      class="hide-scrollbar mt-5 grid max-h-[70vh] grid-cols-1 gap-3 overflow-y-auto pr-1"
    >
      <ProjectCard v-for="project in projects" :key="project.title" :project="project" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { projects } from '../data'
import ProjectCard from '../components/ProjectCard.vue'
import { useReveal } from '../composables/useMotion'

const { t } = useI18n()
const root = ref<HTMLElement | null>(null)
useReveal(root)
</script>
